import axios from "axios";
import {
  getAPIBaseURL,
  getXSPOCAPIBaseURL,
} from "../utilities/baseUrlutility.tsx";
import { handleErrorResponse } from "../utilities/errorHandler.ts";
import TokenService from "./authentication/token.service.ts";

const baseUrl = getAPIBaseURL();
const xspocBaseUrl = getXSPOCAPIBaseURL();

const instance = axios.create({
  baseURL: baseUrl,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    [process.env.REACT_APP_XSPOC_SUBSCRIPTION_KEY_NAME as string]:
      process.env.REACT_APP_XSPOC_SUBSCRIPTION_KEY_VALUE,
  },
});

const xspocApiInstance = axios.create({
  baseURL: xspocBaseUrl,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

instance.interceptors.request.use(
  (config: any) => {
    const correlationId = TokenService.getCorrelationId();
    if (correlationId) {
      config.headers['xspoc-ui-tracking-id'] = correlationId;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

instance.interceptors.response.use(
  function (response: any) {
    return response;
  },
  function (error) {
    handleErrorResponse(error);
    return Promise.reject(error);
  }   
);

xspocApiInstance.interceptors.request.use(
  (config: any) => {
    const correlationId = TokenService.getCorrelationId();
    if (correlationId) {
      config.headers['xspoc-ui-tracking-id'] = correlationId;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

xspocApiInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    let message;
    if (error.response && error.response.data && error.response.data.message) {
      message = error.response.data.message;
    } else {
      message = handleErrorResponse(error);
    }
    return Promise.reject({ ...error, message });
  }
);

export default instance;
export { xspocApiInstance };
